<template>
  <div>
    <v-alert v-model="alert" type="info" dismissible>
      Report generation request is submitted. Please check the status of the process at the <a @click="goToMessageCenter">message center</a>.
    </v-alert> 
    <ExecutionResultsDialog title="Report generation" ref="executionResultsDialog">
      <template #actions="{ isError, fileResults }">
        <SecondaryBtn @click="downloadResults(fileResults)" v-if="isError && fileResults && fileResults.length> 0">
          Download anyway
        </SecondaryBtn>
      </template>
    </ExecutionResultsDialog>
    <!-- <v-btn :disabled="disabled && !isGeneratingReport" color="info" :loading="isGeneratingReport" @click="generateReport()">
      <v-icon class="mr-2">save_alt</v-icon>
      <div class="text-capitalize"> {{ $t("Button.DownloadReport") }}</div>
    </v-btn> -->

    <v-btn :disabled="isSubmittingReportRequest" color="info" :loading="isSubmittingReportRequest" @click="generateReportAsync()">
      <v-icon class="mr-2">save_alt</v-icon>
      <div class="text-capitalize"> Asynchronous Report Download</div>
    </v-btn>
  </div>
</template>

<script>
  import {
    downloadFileBytes,
  } from '@/helpers/download'
  import {
      createNamespacedHelpers,
    } from 'vuex'
  import {
    reportTypes,
    reportGroupings,
    makeContinuousRequestData,
  } from '@/helpers/multiStationQuery'

  export const maxTimeout = 240000 // 4 minutes
  const multiStation = createNamespacedHelpers('multistation')
  export default {
    props: {
      selection: Object,
      reportOptions: Object,
      disabled: Boolean,
    },
    data: () => ({
      isGeneratingReport: false,
      isSubmittingReportRequest: false,
      alert: false,
    }),
    computed: {
      reportGenerator() {
        return this.$store.getters['multistation/reportGenerator']
      },
    },
    watch: {
      'report.reportFormat'(val) {
        if (val == reportTypes.standard && this.reportOptions.organizeWorksheetBy == reportGroupings.station) {
          this.reportOptions.organizeWorksheetBy = reportGroupings.stationMedia
        }
      },
      isGeneratingReport(val) {
        this.$emit('loading', val)
      },
    },
    methods: {
      ...multiStation.mapActions(['generateCDQReportAsync']),
      downloadResults(fileResults) {
        // Only expecting one file result
        fileResults.forEach(({
          fileName,
          data,
        }) => {
          downloadFileBytes(fileName, data)
        })

        this.$store.dispatch('app/setSnackbar', {
          text: 'Report downloaded.',
          color: 'success',
          icon: 'done',
        })
      },
      async timeoutLimit(source, isRequestDone) {
        setTimeout(() => {
          if (isRequestDone) return
          source.isCancelled = true
          source.cancel()
        }, maxTimeout)
      },
      // async generateReport() {
      //   this.isGeneratingReport = true
      //   this.$store.dispatch('app/setSnackbar', {
      //     text: 'Please wait as the report may take one to two minutes to generate depending on how much data is requested.',
      //     color: 'info',
      //     icon: 'info',
      //     timeout: 0,
      //   })

      //   let requestData
      //   try {
      //     requestData = makeContinuousRequestData(this.selection, this.reportOptions, this.reportGenerator.Id)
      //   } catch (error) {
      //     this.$store.dispatch('app/setSnackbar', {
      //       text: error,
      //       color: 'error',
      //       icon: 'error',
      //     })

      //     this.isGeneratingReport = false
      //     return
      //   }

      //   let {
      //     responsePromise,
      //     source,
      //   } = await this.$store.dispatch('multistation/generateContinuousDataReport', requestData)

      //   // Cancel request if it takes too long
      //   let isRequestDone = false
      //   this.timeoutLimit(source, isRequestDone)

      //   try {
      //     let data = await responsePromise
      //     const {
      //       fileResults,
      //       isError,
      //     } = data

      //     // If error or no file results
      //     if (isError || !fileResults || fileResults.length === 0) {
      //       this.$refs.executionResultsDialog.show(data)
      //     }

      //     this.downloadResults(fileResults)
      //   } catch (error) {
      //     console.error(error)


      //     this.$refs.executionResultsDialog.show(error)
      //   } finally {
      //     this.isGeneratingReport = false
      //     isRequestDone = true
      //   }
      // },
      async generateReportAsync() {
        this.isSubmittingReportRequest = true
        let requestData = makeContinuousRequestData(this.selection, this.reportOptions, this.reportGenerator.Id)
        console.log(requestData)
        await this.generateCDQReportAsync(requestData)
        
        this.alert = true
        this.isSubmittingReportRequest = false
      },
      goToMessageCenter() {
        this.$router.push({
          name: 'MessageCenter',          
        })
      },
    },
  }
</script>